// extracted by mini-css-extract-plugin
module.exports = {"spm-menu-line-item":"Line_spm-menu-line-item__3DoDM","disabled":"Line_disabled__2VGIJ"};